import { render } from "./LinkInvalido.vue?vue&type=template&id=48163e18"
import script from "./LinkInvalido.vue?vue&type=script&lang=js"
export * from "./LinkInvalido.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Desenvolvimento\\projetos\\web\\cliqx.checkout.frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__